@if (showTestBanner) {
    <app-test-banner [position]="'bottom-left'" />
}
<router-outlet></router-outlet>
